import { useListUsers as useListUsersQuery } from 'v2/core/repository/edge-server/listUsers';
import { Response } from 'v2/core/services/types';
import { useGetUser } from 'v2/core/services/user';
import {
  ListUsersFilter,
  ListUsersItem,
  UseListUsersResponse,
} from 'v2/core/repository/edge-server/types/listUsers';

interface UseListUsersProps {
  filter?: ListUsersFilter;
}

export const useListUsers = (
  input?: UseListUsersProps,
  onCompleted?: (users: ListUsersItem[]) => void,
): Response<UseListUsersResponse> => {
  const {
    tenant: { id: tenantID },
  } = useGetUser();

  const { data, status, error } = useListUsersQuery(
    {
      tenantID,
      filter: input?.filter,
    },
    onCompleted,
  );

  return {
    data,
    status,
    error,
  };
};
